function getScaleValue(selector) {
  const element = document.querySelector(selector);
  if (!element) return null;

  const style = window.getComputedStyle(element);
  const transform =
    style.transform || style.webkitTransform || style.mozTransform;

  if (transform === 'none') return 1;

  const matrix = transform.match(/^matrix\((.+)\)$/);
  if (matrix) {
    const values = matrix[1].split(', ');
    return parseFloat(values[0]); // Значение scale находится в первом элементе матрицы
  }

  return null;
}

export default getScaleValue;
